import { useDispatch } from 'react-redux'

import { closeGraphQLSubscriptions } from '~/api/graphql/graphqlCore'
import { clearLogOutTime, logout } from '~/store/actions/auth'
import { wsDisconnect } from '~/store/duck/websocket'

const usePreLogoutCleanup = () => {
  const dispatch = useDispatch()

  return () => {
    closeGraphQLSubscriptions()
    dispatch(logout())
    dispatch(wsDisconnect())
    dispatch(clearLogOutTime())
  }
}

export default usePreLogoutCleanup
